import React, { useEffect, useState, useContext } from 'react';
import Template from './template';
import { FamilyMoveServiceInfo } from 'components';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import { apiGetServiceInfo } from 'api/ZimssaAPI';
import { useApiRequest } from 'hooks';
import { getCarrierYear } from 'commons/ZimssaHelper';
import { PAGE_SERVICE_FAMILYMOVE, ITEM_INFO_ARRANGE_LICENSE } from 'commons/ZimssaString';
import { CERT_INFO } from 'router/PageUrl';

function FamilyMoveServiceInfoView(): React.ReactElement {
    const { service, isOwner } = useContext(PartnerAuthState);
    const familymove = service.find((item) => item.serviceType === 'family_move');
    const serviceIdx = familymove?.serviceIdx;
    const [serviceInfo, setServiceInfo] = useState<IFamilyMoveInfoState>(defaultState);
    const [fetchResult, fetchService] = useApiRequest<any>(apiGetServiceInfo);

    useEffect(() => {
        if (serviceIdx) {
            fetchService({ type: 'REQUEST', body: ['familymove', serviceIdx] });
        }
    }, [fetchService, serviceIdx]);

    useEffect(() => {
        const { result, data } = fetchResult;
        if (result === 'success') {
            const carInfoArray: Array<{
                size: string;
                type: string;
                etc: string;
                count: number;
            }> = data.carInfo;

            const car: Array<{
                count: string;
                info: string;
            }> = carInfoArray.map((item, index) => ({
                count: `${item.count}`,
                info: `${item.size} / ${item.type} / ${item.etc}`,
            }));

            setServiceInfo({
                email: data.partner.email,
                carrierYear: data.serviceUser.carrierYear,
                serviceImage: data.service.serviceImage,
                serviceOwner: data.partner.owner,
                location: `${data.service.location1} ${data.service.location2}`,
                introduce: data.service.introduce,
                franchiseName: data.familyMove.isFranchise === '1' ? data.familyMove.franchiseName : undefined,
                car: car,
                businessRegistration: `${data.service.businessRegistrationOwner} / ${data.service.businessRegistrationNumber} / ${data.service.taxClassification}`,
                arrangeLicenseImage: data.familyMove.arrangeLicenseImage,
                isindemnityInsurance: data.familyMove.indemnityInsuranceImage ? true : false,
            });
        }
    }, [fetchResult]);

    const familyMoveServiceInfoProps = {
        email: serviceInfo.email,
        carrierYear: getCarrierYear(Number(serviceInfo.carrierYear)),
        serviceImage: serviceInfo.serviceImage,
        serviceOwner: serviceInfo.serviceOwner,
        franchiseName: serviceInfo.franchiseName,
        location: serviceInfo.location,
        introduce: serviceInfo.introduce,
        car: serviceInfo.car,
        businessRegistration: {
            contents: serviceInfo.businessRegistration,
            href: `${CERT_INFO.url}/businessregistration/familymove/${familymove?.serviceIdx}`,
        },
        arrangeLicense: {
            contents: ITEM_INFO_ARRANGE_LICENSE,
            href: `${CERT_INFO.url}/arrangelicense/familymove/${familymove?.serviceIdx}`,
        },
        isindemnityInsurance: serviceInfo.isindemnityInsurance ? `${CERT_INFO.url}/indemnityinsurance/familymove/${familymove?.serviceIdx}` : undefined,
        isOwner: isOwner,
    };

    return (
        <Template title={PAGE_SERVICE_FAMILYMOVE} serviceType={'familymove'} serviceIdx={serviceIdx ? serviceIdx : 0}>
            <FamilyMoveServiceInfo {...familyMoveServiceInfoProps} />
        </Template>
    );
}

export default FamilyMoveServiceInfoView;

interface IFamilyMoveInfoState {
    email: string;
    carrierYear: string;
    serviceImage: string;
    serviceOwner: string;
    franchiseName?: string;
    location: string;
    introduce: string;
    car: Array<{
        count: string;
        info: string;
    }>;
    businessRegistration: string;
    arrangeLicenseImage: string;
    isindemnityInsurance: boolean;
}

const defaultState: IFamilyMoveInfoState = {
    email: '',
    carrierYear: '',
    serviceImage: '',
    serviceOwner: '',
    location: '',
    introduce: '',
    car: [],
    businessRegistration: '',
    arrangeLicenseImage: '',
    isindemnityInsurance: false,
};
